<div class=linear>
  <mat-form-field mat-error >
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search...">
      
    </mat-form-field>
    <button *ngIf="showAddButton" mat-raised-button (click)="addInstructor()"> Add Instructor </button>
</div>
<div *ngIf="instructors?.data?.length > 0 "class='page'>


      <table 
        *ngIf="!superAdmin"
        mat-table [dataSource]="instructors" class="mat-elevation-z8 stretch" >
      
        
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let instructor"> {{instructor?.firstname + ' ' + instructor?.lastname}} </td>
          
        </ng-container>
    
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let instructor"> {{instructor?.email}} </td>
        </ng-container>
      
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef> City </th>
          <td mat-cell *matCellDef="let instructor"> {{instructor?.city}} </td>
        </ng-container>
      
        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef> Country </th>
          <td mat-cell *matCellDef="let instructor"> {{instructor?.country}} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <table mat-table [dataSource]="instructors" class="mat-elevation-z8 stretch" *ngIf="!!superAdmin">
      
        
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let instructor"> {{instructor?.firstname + ' ' + instructor?.lastname}} </td>
        </ng-container>
    
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let instructor"> {{instructor?.email}} </td>
        </ng-container>

        <ng-container matColumnDef="permissions">
          <th mat-header-cell *matHeaderCellDef> Permissions </th>
          <td mat-cell *matCellDef="let instructor"   [ngClass]="{'red': !aperm[instructor?.uid] && !iperm[instructor?.uid], 'orange': !!aperm[instructor?.uid] && !!iperm[instructor?.uid]  }"> 
            <div class="hori">
                <span [ngClass]="{'strike': !aperm[instructor?.uid], 'green': aperm[instructor?.uid] && !iperm[instructor?.uid] }">Admin</span>
                &nbsp;
                <span [ngClass]="{'strike': !iperm[instructor?.uid], 'green': iperm[instructor?.uid] && !aperm[instructor?.uid] }">Instructor </span>
                &nbsp;
                  <mat-icon 
                  *ngIf="!!aperm[instructor?.uid] && !!iperm[instructor?.uid]"
                  aria-hidden="false" 
                  aria-label="Warning Icon"
                  matTooltip="{{instructor?.firstname}} has both Admin and Instructor permissions.  This may cause unknown behaviors."
                  >warning</mat-icon>

                <mat-icon 
                  *ngIf="!aperm[instructor?.uid] && !iperm[instructor?.uid]" 
                  aria-hidden="false" 
                  matTooltip="{{instructor?.firstname}} has no permissions set.  They will not able able to access their School Page"
                  aria-label="Error Icon">error</mat-icon>


                <button 
                  mat-raised-button
                  matTooltip="Make {{instructor?.firstname}} an Instructor"
                  *ngIf="!aperm[instructor?.uid] && !iperm[instructor?.uid]" 
                  color="warn" 
                  (click)="setInstructor(instructor)">Make Instructor</button>
                <button 
                  mat-raised-button
                  matTooltip="Make {{instructor?.firstname}} an Admin"
                  *ngIf="!aperm[instructor?.uid] && !iperm[instructor?.uid]"
                  color="error" 
                  (click)="setAdmin(instructor)">Make Admin</button>
             </div>

          
          </td>
        </ng-container>

        <ng-container matColumnDef="entityId">
          <th mat-header-cell *matHeaderCellDef> EntityId/Shortname </th>
          <td mat-cell *matCellDef="let instructor"> <span [ngClass]="{'error': instructor?.entityId !== entityId }">{{instructor?.entityId}}</span> 
            <button *ngIf="instructor?.entityId !== entityId" style="margin-left: 1em;" color="warn" mat-raised-button (click)="fixEntityId(instructor)" >Set to {{entityId}} </button> </td>
        </ng-container>
     
        <ng-container matColumnDef="uid">
          <th mat-header-cell *matHeaderCellDef> UID </th>
          <td mat-cell *matCellDef="let instructor"> 
              <a 
                target="_blank" 
                href="https://console.firebase.google.com/u/0/project/studies-151020/firestore/data/Profiles/{{instructor.uid}}">{{instructor?.uid}}</a> 
            </td>
        </ng-container>
        <ng-container matColumnDef="organization">
          <th mat-header-cell *matHeaderCellDef> Organization ID </th>
          <td mat-cell *matCellDef="let instructor">
             <a 
              target="_blank"
              href="https://console.firebase.google.com/u/0/project/studies-151020/firestore/data/Organizations/{{instructor.organization}}">{{instructor?.organization}}</a> 
          </td>
        </ng-container>

        <ng-container matColumnDef="preferences">
          <th mat-header-cell *matHeaderCellDef> Preferences </th>
          <td mat-cell *matCellDef="let instructor">Email Enabled: {{instructor?.preferences?.notifications?.emailsEnabled ? "Yes" : "No"}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
</div>


